import React from 'react';

import { QuestionMultiChoiceWithText, QuestionTypeV2 } from '../../../redux/types';
import ChoiceTextQuestionEditor from '../ChoiceTextQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionMultiChoiceWithText;
  addQuestion?: (dq: Omit<QuestionMultiChoiceWithText, 'id'>) => void
  updateQuestion?: (dq: QuestionMultiChoiceWithText) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
  enableTNA?: boolean;
}

const MultiChoiceWithTextQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
  enableTNA,
}: Props) => (
  <ChoiceTextQuestionEditor<QuestionMultiChoiceWithText>
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    type={QuestionTypeV2.MultiChoiceWithText}
    disableHideAggregation={disableHideAggregation}
    enableTNA={enableTNA}
  />
);

export default MultiChoiceWithTextQuestionEditor;
